import React from "react";
import { UserIcon } from "../icons";

const UserMessage: React.FC<{ message: string }> = ({ message }) => {
  return (
    <div className="message-container">
      <div className="user-message">
        <span>
          <div className="text">{message}</div>
          <div className="icon">
            <UserIcon />
          </div>
        </span>
      </div>
    </div>
  );
};

export default UserMessage;
